import { Component } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { environment } from '../environments/environment';
import { InstiComponent } from './insti/insti.component';
//import {InstiService} from './insti/insti.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends InstiComponent{
     /*
    constructor(private router: Router,
                private service: InstiService
                ){
        
            let excepts_urls=[this.service.getLoginUrl(true), this.service.getLogoutUrl(true)];
            var instance=this;
            
         this.router.events.subscribe((event: Event) => {
             
             var current_url=event.url;
             
             if(excepts_urls.indexOf(current_url)>-1){
                 return null;                 
             }
             if(!instance.service.isLogged()){
                  instance.service.showAlert('Você não tem permissão para acessar esta página', 'Faça o login e tente novamente', 'error');
                  //return false;
                  instance.router.navigate([instance.service.getLoginUrl(true)]);
             }
             
            if (event instanceof NavigationStart) {
                event.url; //Ex: "/natureza51/cargo";
                var a=event;
            }

            if (event instanceof NavigationEnd) {
                // Hide loading indicator
                 var a=event;
            }

            if (event instanceof NavigationError) {
                // Hide loading indicator
                // Present error to user
                 var a=event;
                
            }
            var b=a;
        });
    }
    */
}
